import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import LandingShell from '../components/landing/LandingShell';
import ResultVideoTile from '../components/results/ResultVideoTile';
import { hasConsent } from '../components/results/ResultCard';
import { resultVideos } from '../data/results';

/*
 * Public /stories — video testimonials, split out of /results so results and
 * voices are two separate pages rather than one long scroll. The navbar's
 * "Stories" link and the homepage strip's "Watch all stories" both land here;
 * /results links across at its foot, and this page links back.
 *
 * Every tile is a click-to-play YouTube facade (see ResultVideoTile): the
 * initial DOM contains no iframe and no request to youtube.com or google is
 * made until the visitor actually taps a video.
 *
 * CONSENT GATE — filtered here and again inside the tile, same as everywhere
 * else these students appear.
 */

const StoriesPage = () => {
  const videos = resultVideos.filter(hasConsent);

  return (
    <LandingShell>
      <section className="bg-brand-mist">
        <div className="mx-auto max-w-[1180px] px-5 py-9 lg:px-11 lg:py-[76px] lg:text-center">
          <h1 className="text-[25px] lg:text-[38px] font-extrabold leading-tight text-brand-deep tracking-[-0.02em] lg:tracking-[-0.025em] mb-1.5 lg:mb-2.5">
            Students speak
          </h1>
          <p className="text-sm lg:text-[15.5px] text-brand-slate">
            Unscripted, filmed at our Sector 49 centre. Tap a video to play — nothing loads until
            you do.
          </p>
        </div>
      </section>

      <section id="stories" className="scroll-mt-16 lg:scroll-mt-20 bg-brand-deep">
        <div className="mx-auto max-w-[1180px] px-5 py-9 lg:px-11 lg:py-[76px]">
          {videos.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-5">
              {videos.map((entry) => (
                <ResultVideoTile key={entry.id} entry={entry} />
              ))}
            </div>
          ) : (
            <p className="text-sm lg:text-[15px] text-white/50 border border-white/[0.14] rounded-xl px-4 py-6 text-center">
              No consented stories published yet — check back soon.
            </p>
          )}
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-[1180px] px-5 py-9 lg:px-11 lg:py-14 lg:flex lg:items-center lg:justify-between lg:gap-10">
          <div>
            <h2 className="text-[22px] lg:text-[30px] font-extrabold leading-tight text-brand-deep tracking-[-0.02em] mb-1.5">
              See what they scored
            </h2>
            <p className="text-sm lg:text-[15.5px] text-brand-slate mb-5 lg:mb-0">
              Board marks, entrance scores and university admissions, batch by batch.
            </p>
          </div>
          <Link
            to="/results"
            className="inline-flex items-center gap-2 px-5 py-[13px] rounded-[9px] bg-brand-deep text-[14.5px] font-bold text-white"
          >
            View all results
            <ArrowRight className="w-[17px] h-[17px]" />
          </Link>
        </div>
      </section>
    </LandingShell>
  );
};

export default StoriesPage;
